// The 15 s connect timer is already armed when a grant refresh runs, so every ms spent here is
// taken out of the rebuild's connect window; 3 s bounds that cost yet tolerates a slow pong.
export const REFRESH_TIMEOUT_MS = 3_000;
